import { getAuthOptions } from '@/api';
import { AuthProviders } from '@/interfaces';
import { Status } from '@prometheus/types';
import { useEffect, useState } from 'react';

export const useLoginOptions = () => {
  const [state, setState] = useState<AuthProviders>({});
  const [status, setStatus] = useState(Status.INITIAL);

  const getOptions = async () => {
    setStatus(Status.IN_PROGRESS);
    try {
      const result = await getAuthOptions();
      setState(result);
      setStatus(Status.SUCCESS);
    } catch (err) {
      console.error(err);
      setStatus(Status.ERROR);
    }
  };

  useEffect(() => {
    getOptions();
  }, []);
  return {
    loginOptions: state,
    status,
    getLoginOptions: getOptions,
  };
};
